import { OppgaveStatusValue } from "enums/oppgaveStatus";
import { Feltnavn } from "HNEntities/endringer";
import type { HNOppgaveFrontend } from "HNResources";

const getOppgaveStatusText = (
  nyVerdi: string,
  resources: HNOppgaveFrontend | undefined,
  statusBegrunnelse?: string,
): string => {
  const nyVerdiLowerCase = nyVerdi.trim().toLowerCase();
  let textToReturn = `${resources?.endringslogg_status} ${nyVerdiLowerCase}`;

  if (
    nyVerdiLowerCase === OppgaveStatusValue.Cancelled ||
    nyVerdiLowerCase === OppgaveStatusValue.EnteredInError
  ) {
    textToReturn = resources?.endringslogg_status_kansellert || "";
  }

  if (statusBegrunnelse) {
    return `${textToReturn} - ${statusBegrunnelse}`;
  } else {
    return textToReturn;
  }
};

export const getEndringTypeText = (
  feltNavn: Feltnavn,
  resources: HNOppgaveFrontend | undefined,
  nyVerdi?: string,
  statusBegrunnelse?: string,
): string => {
  switch (feltNavn) {
    case Feltnavn.Notat:
      if (nyVerdi) {
        return `${resources?.endringslogg_notat} ${nyVerdi}`;
      } else return "";
    case Feltnavn.OppgaveStatus:
      if (nyVerdi) {
        return getOppgaveStatusText(nyVerdi, resources, statusBegrunnelse);
      } else return "";
    case Feltnavn.Beskrivelse:
      return resources?.endringslogg_beskrivelse || "";
    case Feltnavn.Frist:
      if (nyVerdi) {
        return `${resources?.endringslogg_frist} ${nyVerdi}`;
      } else return "";
    default:
      return "";
  }
};
